/** Attach admin JWT when present. */
export function adminAuthHeaders(extra = {}) {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

/** Extract a user-facing message from axios/fetch errors. */
export function getApiErrorMessage(err, fallback = "Something went wrong") {
  const data = err?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.message) return String(data.message);
  if (data?.error) return String(data.error);
  if (err?.message) return String(err.message);
  return fallback;
}
